<template>
  <div class="rootDiv">
    <header class="mint-header is-fixed" style="border-bottom: 1px solid gainsboro;background:white;">
      <div class="div_left">
        <div v-if="AllSelected">
          <img src="../../../assets/images/32/unselect_all.png" @click="UnSelectAll" style="margin: 0;padding: 0"
               height="25"
               width="25"
               slot="icon" alt="">
        </div>
        <div v-else>
          <img src="../../../assets/images/32/select_all.png" @click="SelectAll" style="margin: 0;padding: 0"
               height="25"
               width="25"
               slot="icon" alt="">
        </div>
      </div>
      <div style="width: 30rem;height: 32px;" class="mint-search searchstyle">
        <div class="mint-searchbar" style="padding: 0">
          <div class="mint-searchbar-inner">
            <i class="mintui mintui-search"/>
            <input type="search" placeholder="搜索" class="mint-searchbar-core" style="color: black" v-model="searchKey"
                   @input="search()"/>
            <a class="mint-searchbar-cancel" style="display: none;">取消</a>
          </div>
          <div class="mint-search-list" style="display: none;">
            <div class="mint-search-list-warp"/>
          </div>
        </div>
      </div>
      <div class="div_right">
        <div>
          <img src="../../../assets/images/32/delete_birthday.png" @click="DeleteBirthday"
               style="margin-left:10px ;padding: 0" height="25"
               width="25"
               slot="icon" alt="">
        </div>
        <div>
          <img src="../../../assets/images/32/add_birthday.png" @click="AddBirthday" height="25" width="25"
               slot="icon" alt="">
        </div>
      </div>
    </header>
    <div style="clear:both;margin-top: 3rem">
      <ul v-for="item in BirthdayList" :key="item.iD">
        <li class="listyle">
          <CellSwipe style="margin-top: -0.5rem;"
                     :right="[ {
                    content: '编辑',
                    style: { background:'#d24b4b', color: '#fff'},
                    handler: () => editBirthday(item)
                }
            ]">
            <div class="mint-cell-title"
                 style="position: absolute; width: 100%; height: 100%; left: 0; top: 0;">
              <label class="mint-checklist-label" style="text-align: left;margin-top: 0.6rem">
                <div style="float: left">
                  <span class="mint-checkbox">
                  <input type="checkbox" style="z-index: -99" class="mint-checkbox-input" :value="item.iD"
                         v-model="item.isSelected">
                  <span class="mint-checkbox-core"/>
                </span>
                </div>
                <div style="float: left;width: 4rem">
                  <span class="mint-checkbox-label" style="color: green">{{ item.name }}</span>
                </div>
                <div style="float: left;width: 11rem">
                  <img style="vertical-align: middle" v-if="item.sex === '男'" src="../../../assets/images/16/man.png"
                       alt=""/>
                  <img style="vertical-align: middle" v-else src="../../../assets/images/16/woman.png" alt=""/>
                  <span class="mint-checkbox-label">{{ item.dateOfBirth }}</span>
                </div>
                <div style="float: left">
                  <span class="mint-checkbox-label" style="color: #d24b4b">{{ item.remarks }}</span>
                </div>
              </label>
            </div>
          </CellSwipe>
        </li>
      </ul>
      <Divider><span>总计：{{ BirthdayList.length }}个生日</span></Divider>
    </div>
  </div>
</template>

<script>
import {CellSwipe} from 'mint-ui';
import Birthday from "./Birthday";
import {Divider} from 'vant';
import 'vant/lib/divider/index.css'

export default {
  name: "BirthdayManager",
  components: {CellSwipe, Divider},
  data() {
    return {
      searchKey: null,
      BirthdayList: [],
      BirthdayList_Temp: [],
      AllSelected: false,
      Birthday: Birthday.data().Birthday,
      yhnm: localStorage.getItem('yhnm'),
      token: localStorage.getItem('token'),
      getBirthdayListUrl: '/api/business/getBirthdayList',
      deleteBirthdayListUrl: '/api/business/deleteBirthdayList',
    }
  },
  mounted() {
    this.getBirthdayList()
  },
  methods: {
    search() {
      if (this.searchKey === null) {
        return
      }
      if (this.searchKey === '') {
        this.BirthdayList = this.BirthdayList_Temp
        return
      }
      let temp = []
      this.BirthdayList_Temp.forEach(item => {
        if (item.name.includes(this.searchKey)) {
          temp.push(item)
        }
      })
      this.BirthdayList = temp
    },
    AddBirthday() {
      this.$router.push({path: 'm_birthday_add', query: {sfqnsr: '0'}})
    },
    DeleteBirthday() {
      let that = this
      let bo = false
      let selected = []
      this.BirthdayList.forEach(item => {
        if (item.isSelected) {
          bo = true
          selected.push(item.iD)
        }
      })
      if (!bo) {
        this.$toast({
          message: "未选中任何项",
          position: 'middle',
        });
        return
      }
      let lenth = selected.length
      this.$messagebox.confirm("确认删除选中的" + lenth + "项?").then(action => {
        if (action === 'confirm') {
          let selected_json = JSON.stringify(selected)
          that.$ajax({
            method: 'POST',
            url: that.deleteBirthdayListUrl,
            data: {idList: selected_json},
            headers: {token: that.token}
          }).then((response) => {
            if (response.data['result'])
              this.$router.go(0)
            else
              this.$messagebox.alert(response.data.message, '批量删除失败')
          }).catch(response => {
            that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
          });
        }
      })
    },
    SelectAll() {
      this.AllSelected = true
      this.BirthdayList.forEach(item => {
        this.$set(item, 'isSelected', true)
      })
    },
    editBirthday(birth) {
      this.$router.push({path: 'm_birthday_add', query: {birth: birth}})
    },
    UnSelectAll() {
      this.AllSelected = false
      this.BirthdayList.forEach(item => {
        this.$set(item, 'isSelected', false)
      })
    },
    async getBirthdayList() {
      let that = this
      await this.$ajax({
        method: 'get',
        url: this.getBirthdayListUrl,
        params: {yhnm: this.yhnm, sortType: "1"},
        headers: {token: this.token}
      }).then((response) => {
        if (response.data.result) {
          this.BirthdayList = response.data['responseData']
          this.BirthdayList_Temp = response.data['responseData']
          this.BirthdayList.forEach(item => {
            this.$set(item, 'isSelected', false)
          })
        } else {
          that.$messagebox.alert(response.data.message)
        }
      }).catch(response => {
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.rootDiv {
  ul {
    list-style-type: none;
    margin: 0;

    li {
      height: 3rem;
      //margin-left: -2.5rem;
    }
  }
}

.div_left {
  float: left;
  width: 50%;
  padding-top: 18px;

  div {
    float: left;
    line-height: 40px;
  }
}

.div_right {
  float: right;
  width: 50%;
  padding-top: 18px;

  div {

    float: right;
    line-height: 40px;
  }
}
</style>
